'use strict';

var toastr = require('toastr');
var _ = require('lodash');
function ConfigurationBudgetTargetService($q, restangular, $http, $log) {
  var service = restangular.service('staticdata').one('targets');
  var CONFLICT_ERROR_CODE = 409;
  var id;
  function postColumnsSuccessHandler() {
    toastr.success('Successfully saved configuration changes.');
    return $q.resolve();
  }
  function postColumnsErrorHandler(response) {
    if (response.status === CONFLICT_ERROR_CODE) {
      $log.error('ConfigurationBudgetTargetService: postColumnsErrorHandler - Duplicate record exists');
      toastr.error('Duplicate record exists');
    } else {
      var errorMsg = 'Error when saving configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
      $log.error('ConfigurationBudgetTargetService: postColumnsErrorHandler - ' + errorMsg);
      toastr.error(errorMsg);
    }
    return $q.reject();
  }
  function saveConfigurationBudgetTarget(targets) {
    var payload = {
      id: id,
      target: preparePayload(targets)
    };
    return service.one('' + payload.id).customPUT(payload).then(postColumnsSuccessHandler, postColumnsErrorHandler);
  }
  function getSavedTargets(targets) {
    return _.filter(targets, function (element) {
      return element.isNewlyAdded === false;
    });
  }
  function removeTarget(targets) {
    var savedTargets = getSavedTargets(targets);
    if (savedTargets.length) {
      return removeFromServer(savedTargets);
    } else {
      return postColumnsSuccessHandler();
    }
  }
  function removeFromServer(targets) {
    var payload = {
      target: preparePayload(targets)
    };
    return $http({
      method: 'DELETE',
      url: service.getRestangularUrl(),
      data: payload,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(postColumnsSuccessHandler, postColumnsErrorHandler);
  }

  /**
   * Gets spos for save: (AVPRM-20440) if row has LoadFactor target type, it still should be saved with Default spos, but this shouldn't be shown on UI in a cell
   * @param newTarget - grid row
   * @returns {string}
   */
  function getPOS(newTarget) {
    return newTarget.spos && newTarget.targetType !== 'LoadFactor' ? newTarget.spos : 'Default';
  }
  function preparePayload(targets) {
    return _.transform(targets, function (result, item) {
      var newTarget = _.clone(item);
      newTarget.yearMonth = item.year + '-' + item.month + '-01';
      newTarget.spos = getPOS(newTarget);
      delete newTarget.year;
      delete newTarget.month;
      delete newTarget.uid;
      delete newTarget.dataindex;
      delete newTarget._old;
      delete newTarget._original;
      delete newTarget.isNewlyAdded;
      result.push(newTarget);
    });
  }
  function setId(newId) {
    id = newId;
  }
  return {
    saveConfigurationBudgetTarget: saveConfigurationBudgetTarget,
    removeTarget: removeTarget,
    setId: setId
  };
}
ConfigurationBudgetTargetService.$inject = ['$q', 'Restangular', '$http', '$log'];
module.exports = ConfigurationBudgetTargetService;